import styled from 'styled-components';

import { spaceL, spaceXXL, xdlColorText } from '@xingternal/tokens';
import { Headline as HeadlineComponent, Hero as HeroComponent } from '@xingternal/typography';

export const Headline = styled(HeadlineComponent)`
  margin-top: ${spaceL};
  margin-bottom: 20px;

  &::first-letter {
    text-transform: capitalize;
  }
`;

export const Hero = styled(HeroComponent)`
  margin-bottom: ${spaceXXL};

  &::first-letter {
    text-transform: capitalize;
  }
`;

export const Link = styled.a`
  color: ${xdlColorText};

  &:hover,
  &:visited,
  &:active {
    text-decoration: none;
  }
`;
